export default "__VITE_ASSET__Cywdcw8J__"